<template>
  <div class="student">
    <div class="box-card" style="margin-top: 20px">
      <el-form :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="活动列表" prop="name" align="left">
              <el-button style="text-align: left" type="primary" @click="openGoodsModal" icon="el-icon-plus">商品</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="flexRowBtn">
        <el-button type="primary" :disabled="ids.length <= 0 ? true : false" @click="batchSet('time')">批量设置时间</el-button>
        <el-button type="primary" :disabled="ids.length <= 0 ? true : false" @click="batchSet('price')">批量设置价格</el-button>
        <el-button type="primary" :disabled="ids.length <= 0 ? true : false" @click="batchSet('num')">限制数量</el-button>
        <span>限量商品一旦全部售出，即使活动时间未结束也会自动结束活动，商品恢复成原价</span>
      </div>
      <el-table key="multipleTable" ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="page.rows" tooltip-effect="dark" style="margin-top: 0px; width: 100%" border @selection-change="selectionChange">
        <el-table-column type="selection" min-width="40"></el-table-column>
        <el-table-column label="商品" width="230" align="center">
          <template slot-scope="row">
            <div style="display: flex" v-if="row.row.goodsInfo">
              <img style="width: 120px; height: 60px" :src="row.row.goodsInfo.logo ? row.row.goodsInfo.logo : 'http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15743276279534477403800.png'" />
              <div style="margin-left: 10px; width: 130px">
                <span>{{ row.row.goodsInfo.name }}</span>
                <span style="display: block">
                  <span style="color: red">￥{{ row.row.goodsInfo.price }}</span>
                  <span style="text-decoration: line-through;color: rgb(162, 170, 188); ">￥{{ row.row.goodsInfo.originalPrice }}</span>
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="有效时间"  width="200">
          <template slot-scope="row">
            <div v-if="row.row.beginDate">起：{{ row.row.beginDate }}</div>
            <div v-if="row.row.endDate">止：{{ row.row.endDate }}</div>
            <div v-if="row.row.activityCircle">{{ row.row.activityCircle }}</div>
            <div v-if="row.row.fixedBeginDate">{{ row.row.fixedBeginDate }}-{{ row.row.fixedEndDate }}</div>
            <div v-if="!row.row.beginDate" style="color:#409EFF;" @click="selectionChange([row.row]), batchSet('time')">设置时间</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="优惠价">
          <template slot-scope="scope">
            <div class="flexCell">
              <el-input @change="confirmEdit(scope.row, scope.$index, 'discountPrice')" v-model="scope.row.discountPrice" type="number" placeholder="请输入" size="mini"></el-input>
              元
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="limitQuantity" label="限量"></el-table-column>
        <el-table-column prop="sellCount" label="活动销量"></el-table-column>
        <el-table-column prop="activityState" label="活动状态"></el-table-column>
        <el-table-column prop label="操作" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span class="mainColor" v-if="scope.row.beginDate && scope.row.discountPrice" @click="upDownGoods(scope.row)">{{ scope.row.sell == 1 ? '下架' : '上架' }}</span>
              <span class="mainColor" @click="deleteAc(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination background layout="total, prev, pager, next" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination> -->
    </div>
    <goods-select ref="goodsSelect" @selectGoodsChange="getSelectGoods"></goods-select>
    <el-dialog :title="modalTitle" :visible.sync="batchSetVisible" :close-on-click-modal="false" width="70%">
      <el-form :label-width="formLabelWidth" ref="acForm">
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="24" v-if="setType == 'time'">
            <el-form-item label="活动日期" prop="acTimeRange" align="left">
              <el-date-picker type="datetimerange" v-model="batchSetForm.acTimeRange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="24" v-if="setType == 'time'">
            <el-form-item label="活动周期" prop="acPeriod" align="left">
              <el-checkbox-group @change="periodChange" v-model="batchSetForm.acPeriod">
                <el-checkbox v-for="(items, indexs) in weekList" :key="indexs" :label="items.options"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="24" v-if="setType == 'time'">
            <el-form-item label="固定时间" prop="solidTime" align="left">
              <el-time-picker is-range v-model="batchSetForm.solidTime" format="HH:mm:ss" value-format="HH:mm:ss" align="right" unlink-panels range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="24" v-if="setType == 'price'">
            <el-form-item label="价格" prop="price" align="left">
              <el-input type="number" v-model="batchSetForm.price" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="24" v-if="setType == 'num'">
            <el-form-item label="数量" prop="num" align="left">
              <el-input type="number" v-model="batchSetForm.num" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button type="primary" @click="confirmSet">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import md5 from "md5";
import goodsSelect from './goodsSelect.vue'
export default {
  components: { goodsSelect },
  data () {
    return {
      batchSetVisible: false,
      activityId: '',
      formLabelWidth: "70px",
      activeName: 'first',
      catogeryList: [
        {
          label: '活动列表',
          name: 'first'
        }, {
          label: '创建拼团',
          name: 'second'
        }
      ],
      batchSetForm: {
        acTimeRange: '',
        acPeriod: [],
        solidTime: '',
        price: '',
        num: '',
      },
      weekList: [{ options: '星期一' }, { options: '星期二' }, { options: '星期三' }, { options: '星期四' }, { options: '星期五' }, { options: '星期六' }, { options: '星期日' },],
      groupList: [],
      subjectList: [],
      campusList: [],
      subjectListVisible: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      viewFormVisible: false,
      addFormVisible: true,
      editFormVisible: false,
      importFormVisible: false,
      options: [],
      region: [],
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      searchForm: {
        name: "",
        couponType: '1',
        createTime: "",
      },
      regionTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      studentDetail: {},
      importForm: {},
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/student/upload`,
      fileList: [],
      studentGroupLIst: [],
      loading: false,
      exportLoading: false,
      createList: [],
      setType: '',
      modalTitle: '批量设置时间',
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    },
  },
  methods: {
    upDownGoods (obj) {
      this.$confirm(`确定${obj.sell == 1 ? '下架' : '上架'}吗`, "系统消息", {
        type: "warning",
      }).then(() => {
        if (obj.sell == 1) {
          var params = {
            "idList": [obj.id],
            type:'一元好课'
          }
          this.api.classInfo.activityBatchOff(params).then((result) => {
            if (result.success) {
              this.$message({
                type: "success",
                message: result.message,
              });
              this.pageList();
            } else {
              this.$message.error(result.message);
            }
          })
        } else {
          var params = {
            "idList": [obj.id],
            type: '一元好课'
          }
          this.api.classInfo.activityBatchOn(params).then((result) => {
            if (result.success) {
              this.$message({
                type: "success",
                message: result.message,
              });
              this.pageList();
            } else {
              this.$message.error(result.message);
            }
          })
        }
      })
    },
    batchSet (type) {
      this.setType = type
      if (type == 'time') this.modalTitle = '批量设置时间'
      if (type == 'price') this.modalTitle = '批量设置价格'
      if (type == 'num') this.modalTitle = '批量设置价格'
      this.batchSetVisible = true
    },
    confirmSet () {
      console.log(this.batchSetForm)
      var idArr = []
      this.ids.forEach(v => {
        idArr.push(v.id)
      })
      var params = {}
      if (this.setType == 'time') {
        if (!this.batchSetForm.acTimeRange || this.batchSetForm.acTimeRange.length <= 0) {
          this.$message.error('请输入活动日期')
          return false;
        }
        if (!this.batchSetForm.acPeriod || this.batchSetForm.acPeriod.length <= 0) {
          this.$message.error('请输入活动周期')
          return false;
        }
        params = {
          ids: idArr,
          activityCircle: this.batchSetForm.acPeriod ? this.batchSetForm.acPeriod.join(',') : '', //周几，周几
          beginDate: this.batchSetForm.acTimeRange[0],//活动结束时间
          endDate: this.batchSetForm.acTimeRange[1],//活动开始时间
          fixedBeginDate: this.batchSetForm.solidTime[0],//固定时间
          fixedEndDate: this.batchSetForm.solidTime[1],
        }
      }
      if (this.setType == 'price') {
        if (!this.batchSetForm.price) {
          this.$message.error('请输入价格')
          return false;
        }
        params = {
          ids: idArr,
          discountPrice: this.batchSetForm.price,//优惠价
        }
      }
      if (this.setType == 'num') {
        if (!this.batchSetForm.num) {
          this.$message.error('请输入数量')
          return false;
        }
        params = {
          ids: idArr,
          limitQuantity: this.batchSetForm.num,//限量
        }
      }
      this.api.classInfo.batchUpdateActivity(params).then(res => {
        this.activityId = ''
        if (res.success) {
          this.createList = []
          this.activeName = 'first'
          this.page.pageNumber = 1;
          this.pageList();
          this.batchSetVisible = false;
          this.batchSetForm = {
            acTimeRange: '',
            acPeriod: [],
            solidTime: '',
            price: '',
            num: '',
          }
        }
      })
    },
    periodChange (val) {
      console.log(val)
    },
    changeRadio (e) {
      this.couponForm.couponType = e.detail.value;
      console.log(this.couponForm.couponType);
    },
    deleteGoods (idx) {
      this.createList.splice(idx, 1)
    },
    confirmEdit (row, idx, type) {
      console.log(row[type], row, 'confirmEdit')
      row[type] = row[type].replace(/[^\d]/g, '')
      var params = {
        "id": row.id,
        'discountPrice': row[type]
      }
      this.api.classInfo.updateActivity(params).then(res => {
        this.activityId = ''
        if (res.success) {
          this.createList = []
          this.activeName = 'first'
          this.page.pageNumber = 1;
          this.pageList();
          this.$message.success('操作成功')
        }
      })
    },
    addConfirm () {
      var api = ''
      if (!this.activityId) {
        api = 'addActivity'
      } else {
        api = 'updateActivity'
      }
      if (!this.searchForm.name) {
        this.$message.error('请输入活动名称')
        return false
      } else if (!this.searchForm.beginDate) {
        this.$message.error('请输入活动时间')
        return false
      }
      var activityGoods = []
      this.createList.forEach((v, k) => {
        activityGoods.push({
          "goodsId": v.id,
          "discount": v.discount,
          "reducePrice": v.reducePrice,
          "activityPrice": v.activityPrice,
          "limitQuantity": v.limitQuantity,
        })
      })
      var params = {
        "name": this.searchForm.name,
        "beginDate": this.searchForm.beginDate,
        "endDate": this.searchForm.endDate,
        "activityGoods": activityGoods
      }
      if (this.activityId) {
        params.id = this.activityId
      }
      this.api.classInfo[api](params).then(res => {
        this.activityId = ''
        if (res.success) {
          this.createList = []
          this.activeName = 'first'
          this.page.pageNumber = 1;
          this.pageList();
          this.$refs.acForm.resetFields()
          this.$message.success(res.message || '操作成功')
        } else this.$message.warning(res.message)
      })
    },
    getSelectGoods (obj) {
      console.log(obj, 'obj')
      this.$nextTick(() => {
        var params = []
        for (var i = 0; i < obj.length; i++) {
          params.push({ goodsId: obj[i].id, type: "一元好课" })
        }
        this.api.classInfo.addActivityBatch(params).then(res => {
          if (res.success) {
            this.pageList();
          }
        })
        console.log(this.createList, 'getSelectGoods')
      })
    },
    openGoodsModal () {
      this.$refs.goodsSelect.openGoodsModal();
    },
    handleClick (val) {
      console.log(this.activeName)
      this.activityId = ''
      this.searchForm.name = ''
      this.searchForm.createTime = ''
      this.searchForm.couponType = '1'
      this.searchForm.beginDate = ''
      this.searchForm.endDate = ''
      this.createList = []
      if (this.activeName == 'first') {
        this.page.pageNumber = 1;
        this.pageList();
      }
    },
    campusChange (val) {
      this.searchForm.campusId = val[2];
    },
    seeOverviewDetails (obj) {
      this.$router.push(`/studentGoodsContent?id=${obj.id}`);
    },
    addRegionChange () {
      this.addForm.regionId = this.region[1];
    },
    editRegionChange () {
      this.editForm.regionId = this.region[1];
    },
    getPageList (id) {
      this.api.goodsInfo
        .getStudentBuyGoodsList({ id: id })
        .then((result) => {
          if (result.data) {
            this.subjectList = result.data;
          } else {
            this.subjectList = [];
          }
          this.subjectListVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },

    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.ids = []
      console.log("val", val);
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
      console.log("this.ids", this.ids);
    },
    getStudent () {
      this.api.student
        .getStudent({
          id: this.selection,
        })
        .then((result) => {
          this.editForm = result.data;
          this.region = this.editForm.regionId;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList () {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      var params = {
        pageSize: 99,
        pageNumber: this.page.pageNumber,
        type: "一元好课"
      }
      this.api.classInfo.activityPageList(params)
        .then((result) => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addStudent () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (this.addForm.campusId) {
            this.addForm.campusId = this.addForm.campusId[2];
          }
          this.addForm.agentId = this.loginData.agentId;
          this.api.student
            .addStudent(this.addForm)
            .then((result) => {
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateStudent () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          // console.log(typeof this.editForm.campusId);
          if (typeof this.editForm.campusId == "object") {
            let index = this.editForm.campusId.length;
            this.editForm.campusId = this.editForm.campusId[index - 1];
          }
          this.editForm.agentId = this.loginData.agentId;
          this.api.student
            .updateStudent(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteStudent (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.student
            .deleteStudent([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteStudent () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.student
            .deleteStudent(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.searchForm.studentGroupIds = [];
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    deleteAc (obj) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        var params = [{ "id": obj.id }]
        this.api.classInfo.deleteActivity(params).then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        })
      })
    },
    viewAddedAc (obj) {
      var params = {
        id: obj.id
      }
      this.api.classInfo.getActivityById(params).then((res) => {
        if (!res.success) return false
        this.activityId = res.data.id
        this.searchForm.name = res.data.name
        this.searchForm.createTime = [res.data.beginDate, res.data.endDate]
        if (res.data.activityGoods && res.data.activityGoods.length > 0) {
          res.data.activityGoods.forEach(v => {
            this.createList.push({
              discount: v.discount,
              reducePrice: v.reducePrice,
              limitQuantity: v.limitQuantity,
              reducePrice: v.reducePrice,
              activityPrice: v.activityPrice,
              logo: v.goodsInfo.logo,
              name: v.goodsInfo.name,
              id: v.goodsId,
              price: v.goodsInfo.price,
              originalPrice: v.goodsInfo.originalPrice,
            })
          })
        } else {
          res.data.activityGoods = []
        }
        this.activeName = 'second'
      })
    },
    checkboxT (row, rowIndex) {
      if (row.remark == "") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "searchForm.createTime": function (newVal) {
      if (newVal) {
        this.searchForm.beginDate = newVal[0];
        this.searchForm.endDate = newVal[1];
      } else {
        this.searchForm.createTime = [];
        this.searchForm.beginDate = "";
        this.searchForm.endDate = "";
      }
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getStudent();
      }
    },
    viewFormVisible: function (newVal) {
      if (!newVal) {
        this.studentDetail = {};
        this.$refs.studentDetail.resetFields();
      } else {
        this.getStudentDetail();
      }
    },
  },
  mounted () {
    this.pageList();
  },
};
</script>
<style scoped>
.answer {
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  color: #409eff;
  text-overflow: ellipsis;
}

.courseManage {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}

.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}

.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}

.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}
</style>
<style lang="less">
.student {
  .el-select {
    width: 100% !important;
  }

  .viewForm {
    .el-dialog__body {
      padding-top: 0px;
    }

    .el-form-item {
      margin-bottom: 0px !important;
    }
  }

  .importForm {
    .el-upload-list {
      display: none !important;
    }
  }
}

.goodBox {
  display: flex;
}

.priceGods {
  display: flex;
  flex-direction: column;
}

.goodsImg {
  width: 120px;
  height: 90px;
}

.btnCenter {
  display: flex;
  margin: 20px 0;
  justify-content: center;
}

.stench {
  width: 64px;
  padding: 0 5px;
  height: 18px;
  border: 1px solid rgb(220, 90, 85);
  color: rgb(220, 90, 85);
  border-radius: 4px;
  font-size: 10px;
  text-align: center;
  background: rgb(255, 255, 255);
  margin-right: 10px;
}

.flexCell {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;

  .el-input__inner {
    width: 90%;
  }
}

.flexRowBtn {
  margin-bottom: 20px;

}
</style>



// WEBPACK FOOTER //
// src/components/conentSaleCenter/oneCentCourse.vue